/*
 * article-toc.js
 *
 * Scans the rendered article body for H2 headings, slugifies their text into
 * stable IDs, and builds a "On this page" anchor list. Hides the whole TOC
 * when the article has fewer H2s than the configured minimum (avoids stub
 * TOCs on short posts).
 */
(function () {
  function slugify(text) {
    return text
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function ensureUniqueId(slug, used) {
    var candidate = slug || 'section';
    var n = 2;
    while (used.has(candidate)) {
      candidate = slug + '-' + n;
      n += 1;
    }
    used.add(candidate);
    return candidate;
  }

  function buildToc(tocEl) {
    var listEl = tocEl.querySelector('[data-article-toc-list]');
    if (!listEl) return;

    var content = document.querySelector('.article-template__content');
    if (!content) return;

    var headings = content.querySelectorAll('h2');
    var minHeadings = parseInt(tocEl.getAttribute('data-toc-min-headings'), 10) || 3;
    if (headings.length < minHeadings) return;

    var usedIds = new Set();
    document.querySelectorAll('[id]').forEach(function (el) { usedIds.add(el.id); });

    var fragment = document.createDocumentFragment();
    var links = [];
    headings.forEach(function (h) {
      if (!h.id) {
        h.id = ensureUniqueId(slugify(h.textContent), usedIds);
      }
      var li = document.createElement('li');
      li.className = 'article-toc__item';
      var a = document.createElement('a');
      a.className = 'article-toc__link';
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      li.appendChild(a);
      fragment.appendChild(li);
      links.push(a);
    });

    listEl.appendChild(fragment);
    tocEl.removeAttribute('hidden');

    enableSmoothScroll(links);
    observeActive(headings, links);
  }

  // Scoped to TOC links only — avoids forcing site-wide `html { scroll-behavior: smooth }`.
  function enableSmoothScroll(links) {
    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        var id = link.getAttribute('href').slice(1);
        var target = document.getElementById(id);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (history.replaceState) {
          history.replaceState(null, '', '#' + id);
        }
      });
    });
  }

  function observeActive(headings, links) {
    if (!('IntersectionObserver' in window)) return;

    var headingToLink = {};
    headings.forEach(function (h, i) { headingToLink[h.id] = links[i]; });

    function setActive(id) {
      links.forEach(function (l) { l.classList.remove('article-toc__link--active'); });
      if (headingToLink[id]) {
        headingToLink[id].classList.add('article-toc__link--active');
      }
    }

    // rootMargin defines a ~25%-tall band near the top of the viewport;
    // the heading inside that band is treated as the current section.
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          setActive(entry.target.id);
        }
      });
    }, {
      rootMargin: '-80px 0px -75% 0px',
      threshold: 0,
    });

    headings.forEach(function (h) { observer.observe(h); });
  }

  function init() {
    document.querySelectorAll('[data-article-toc]').forEach(buildToc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
